import WonderType from '@/roc/wonders/base/WonderType';
import WonderKind from '@/roc/wonders/base/WonderKind';
import WonderOwner from '@/roc/wonders/base/WonderOwner';
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const Petra = {
  id: '134',
  name: 'Petra',
  era: EraType.earlyRome,
  icon: 'petra',
  gameId: 'Petra',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.TEMPLE | WonderKind.FORTRESS,
  kindMultiplier: 1,
  owner: WonderOwner.ARABIA,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.ARABIA_GOODS_PRODUCTION_MOD,
      EffectAmount.asPerLevel([
        10,
        13,
        15,
        16.5,
        18,   // 5
        19.5,
        20.5,
        22.0,
        23.0,
        24.0, // 10
        24.5,
        25.5,
        26.5,
        27,
        28,   // 15
        28.5,
        29,
        30,
        30.5,
        31, // 20
        31.5,
        32.5,
        33,
        33.5,
        34,   // 25
        34.5,
        35,
        35.5,
        36,
        36.5  // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.CAPITAL_CITY_GOODS_PRODUCTION_MOD,
      EffectAmount.asPerLevel([
        5,
        6.5,
        7.5,
        8.2,
        9.0,   // 5
        9.7,
        10.2,
        11.0,
        11.5,
        12.0, // 10
        12.2,
        12.7,
        13.2,
        13.5,
        14,   // 15
        14.2,
        14.5,
        15,
        15.3,
        15.5, // 20
        15.7,
        16.2,
        16.5,
        16.7,
        17,   // 25
        17.2,
        17.5,
        17.7,
        18,
        18.2  // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_ARABIA_WORKER,
      EffectAmount.asCallbackWithLevel(
        function (level) {
          if (level === 30) {
            return 7;
          }
          if (level >= 25) {
            return 6;
          }
          if (level >= 20) {
            return 5;
          }
          if (level >= 15) {
            return 4;
          }
          if (level >= 10) {
            return 3;
          }
          if (level >= 5) {
            return 2;
          }
          return 1;
        }
      ),
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(5).withKind(WonderKind.TEMPLE),
      effect: null,
    }
  ],
};

export default Petra;
